<template>
  <div class="living-options-subsections">
    <div class="row">
      <div class="col-12">
        <div class="subsections">
          <h5>Subsections</h5>
          <button class="btn btn-primary mb-4" @click="addSubsection()" :disabled="isAddingNewObject('subsections')">Add Subsection</button>
          <div>
            Filter Subsections
            <input class="mb-4" type="text" v-model="subsectionFilterText" placeholder="Ground Floor">
          </div>

          <table>
            <thead>
              <tr>
                <th>Label</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="subsection in filteredSubsections"
                :key="subsection._id"
              >
                <td>
                  <div>
                    <toggle-button 
                      v-model="subsection.isEnabled" 
                      :color="{checked: '#28a745', unchecked: '#b8b8b8'}"
                      :sync="true"
                      :width="50" 
                      :height="30"
                      class="mr-2"
                      @change="saveSubsection(subsection)"
                    />
                    {{ subsection.label }}
                  </div>
                </td>
                <td class="text-right table__button-cell">
                  <button class="btn btn-sm btn-outline-danger ml-1" @click="deleteSubsection(subsection._id)">Delete</button>
                  <button class="btn btn-sm btn-outline-secondary ml-1" @click="cloneSubsection(subsection._id)">Clone</button>
                  <button class="btn btn-sm btn-primary ml-1" @click="activeSubsectionId = subsection._id">Edit</button>
                </td>
              </tr>
            </tbody>
          </table>
          <modal-popup :isVisible="!!activeSubsection">
            <div v-if="activeSubsection" class="row modal-row-padding" v-click-outside="closeModal">
              <div class="col-6 mb-4">
                <div class="row">
                  <div class="col-6 mb-4">
                    Subsection Name
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeSubsection.label"
                      placeholder="i.e. apartment"
                    />
                  </div>
                  <div class="col-6 mb-4">
                    Label
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeSubsection.displayName"
                      placeholder="i.e. apartment"
                    />
                  </div>

                  <div class="col-12 mb-4">
                    Subsection Background
                    <input-asset v-model="activeSubsection.backgroundImage" defaultCategory="pageBackground" requirements="Required dimensions: 3040x1960px<br>Supported formats: jpg, png"></input-asset>
                  </div>
                </div>
              </div>

              <div class="col-6 mb-4">
                <div class="row">
                  <div class="col-12 mb-4">
                    Associated Properties
                    <input-multi-select
                      v-model="activeSubsection.propertyIds"
                      :options="propertyOptions"
                    ></input-multi-select>
                  </div>

                  <div class="col-12 mb-4">
                    Associated Subsections*
                    <p><small>*Only populate for subsections that require subsections as children. i.e Building > Floor</small></p>
                    <input-multi-select
                      v-model="activeSubsection.subsectionIds"
                      :options="subsectionOptions"
                    ></input-multi-select>     
                  </div>

                  <div class="col-12 mb-4">
                    Subsection Type*
                    <p><small>*Only populate for subsections that require subsections as children. i.e Building > Floor</small></p>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeSubsection.subsectionType"
                      placeholder="i.e. block, floor, etc."
                    />        
                  </div>
                </div>
              </div>

              <div class="col-12 mb-4">
                Property Placement
                <dot-dropper
                  :background-image="activeSubsection.backgroundImage"
                  v-model="properties"
                  :element-ids="activeSubsection.propertyIds"
                  width="3040"
                  height="2000"
                  dotSize="40"
                ></dot-dropper>
              </div>

              <div class="col-12">
                <button v-if="activeSubsectionId === activeSubsection._id" class="btn btn-sm btn-outline-danger" @click="cancelEdit('subsection')">Cancel</button>
                <button v-if="activeSubsectionId === activeSubsection._id" class="btn btn-sm btn-primary ml-1" @click="saveSubsection(activeSubsection)">Save</button>
              </div>
            </div>             
          </modal-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { FETCH_CONFIG_ITEMS, CONFIG_ITEMS_EDIT } from "@/store/actions.type"
import { mapState } from 'vuex'
import CkEditor from '@/components/CKEditor'
import DotDropper from '@/components/DotDropper'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import CardTabs from '@/components/Cards/TabsCard'
import LivingOptionsMasterplan from './LivingOptionsMasterplan'

export default {
  components: { CardTabs, CkEditor, DotDropper, InputAsset, InputMultiSelect, LivingOptionsMasterplan },
  data () {
    return {
      configItems: [],
      liveHereSidebarMinimap: null,
      liveHereHeading: null,
      liveHereDescription: null,
      liveHereBackground: null,
      livingOptionsConfigItemsKeys: [
        'liveHereSidebarMinimap',
        'liveHereHeading',
        'liveHereDescription',
        'liveHereBackground'
      ],

      activeLivingOptionId: null,
      activeSubsectionId: null,
      activePropertyId: null,
      activePropertyModelId: null,

      propertyFilterText: '',
      propertyModelFilterText: '',
      subsectionFilterText: ''
    }
  },

  computed: {
    activeSubsection () {
      return _.find(this.subsections, subsection => {
        return subsection._id === this.activeSubsectionId
      })
    },

    filteredProperties () {
      return _.filter(this.properties, property => {
        return property.label.toLowerCase().includes(this.propertyFilterText.toLowerCase())
      })
    },

    filteredPropertyModels () {
      return _.filter(this.propertyModels, propertyModel => {
        return propertyModel.label.toLowerCase().includes(this.propertyModelFilterText.toLowerCase())
      })
    },

    filteredSubsections () {
      return _.filter(this.subsections, subsection => {
        return subsection.label.toLowerCase().includes(this.subsectionFilterText.toLowerCase())
      })
    },    

    livingOptions: {
      get () {
        return this.$store.getters.livingOptions
      },
      set (livingOptions) {
        this.$store.commit('SET_LIVING_OPTIONS', livingOptions)
      }
    },
    livingOptionIds () {
      return this.livingOptions.map(livingOption => {
        return livingOption._id
      })
    },
    subsections: {
      get () {
        return this.$store.getters.subsections
      },
      set (subsections) {
        this.$store.commit('SET_SUBSECTIONS', subsections)
      }
    },
    subsectionOptions () {
      let subsectionOptions = []
      this.subsections.forEach(subsection => {
        subsectionOptions.push({
          label: subsection.label,
          value: subsection._id
        })
      })
      return subsectionOptions
    },
    properties: {
      get () {
        return this.$store.getters.properties
      },
      set (properties) {
        this.$store.commit('SET_PROPERTIES', properties)
      }
    },
    propertyOptions () {
      let propertyOptions = []
      this.properties.forEach(property => {
        propertyOptions.push({
          label: property.label,
          value: property._id
        })
      })
      return propertyOptions
    },
    propertyModels: {
      get () {
        return this.$store.getters.propertyModels
      },
      set (properties) {
        this.$store.commit('SET_PROPERTY_MODELS', propertyModels)
      }
    },
  },

  methods: {
    addLivingOption () {
      const livingOption = {
        _id: 'temp',
        label: '',
        displayName: '',
        description: '',
        logo: null,
        marker: {
          x: 100,
          y: 100
        },
        sidebarMinimap: null,
        subsectionImage: null,
        images: [],
        subsectionTypes: '',
        subsectionIds: [],
      }
      this.$store.commit('ADD_LIVING_OPTION', livingOption)
      this.activeLivingOptionId = livingOption._id
    },

    addSubsection () {
      const subsection = {
        _id: 'temp',
        label: '',
        displayName: '',
        order: -1,
        backgroundImage: null,
        marker: {
          x: 100,
          y: 100
        },
        subsectionType: '',
        subsectionIds: [],
        propertyIds: []
      }
      this.$store.commit('ADD_SUBSECTION', subsection)
      this.activeSubsectionId = subsection._id
    },      

    addProperty () {
      const property = {
        _id: 'temp',
        label: '',
        displayName: '',
        marker: {
          x: 100,
          y: 100
        },
        price: '',
        status: '',
        images: [],
        modelIds: [],
        draft: false,
        msq: null,
        view: ''
      }
      this.$store.commit('ADD_PROPERTY', property)
      this.activePropertyId = property._id
    },    

    addPropertyModel () {
      const propertyModel = {
        _id: 'temp',
        label: '',
        displayName: '',
        type: '',
        beds: '',
        baths: '',
        images: []
      }
      this.$store.commit('ADD_PROPERTY_MODEL', propertyModel)
      this.activePropertyModelId = propertyModel._id
    },

    cancelEdit (model) {
      if (model === 'livingOption') {
        this.$store.dispatch('FETCH_LIVING_OPTIONS')
        this.activeLivingOptionId = null
      }

      if (model === 'subsection') {
        this.$store.dispatch('FETCH_SUBSECTIONS')
        this.activeSubsectionId = null
      }

      if (model === 'property') {
        this.$store.dispatch('FETCH_PROPERTIES')
        this.activePropertyId = null
      }

      if (model === 'propertyModel') {
        this.$store.dispatch('FETCH_PROPERTY_MODELS')
        this.activePropertyModelId = null
      }
    },

    cloneSubsection (id) {
      const subsection = _.find(this.subsections, subsection => {
        return subsection._id === id
      })

      let clonedSubsection = _.clone(subsection)

      clonedSubsection._id = 'temp'
      clonedSubsection.label += '-COPY'
      clonedSubsection.isFromCRM = false

      this.$store.commit('ADD_SUBSECTION', clonedSubsection)
      this.activeSubsectionId = clonedSubsection._id
    },

    closeModal () {
      this.$store.dispatch('FETCH_SUBSECTIONS')
      this.activeSubsectionId = null
    },

    deleteSubsection (id) {
      this.$store.dispatch('DELETE_SUBSECTION', id)
    },

    propertiesByIds (ids) {
      const properties =  _.filter(this.properties, property => {
        return ids.includes(property._id)
      })
      return properties
    },    

    propertyModelsByIds (ids) {
      const models =  _.filter(this.propertyModels, model => {
        return ids.includes(model._id)
      })
      return models
    },

    saveConfig () {
      this.configItems.forEach(configItem => {
        this.livingOptionsConfigItemsKeys.forEach(key => {
          if (key === configItem.key) {
            configItem.value = this[key]
          }
        })
      })
      this.$store.dispatch(CONFIG_ITEMS_EDIT, this.configItems)
    },

    subsectionsByIds (ids) {
      const subsections =  _.filter(this.subsections, subsection => {
        return ids.includes(subsection._id)
      })
      return subsections
    },

    subsectionMarkersByIds (ids) {
      const subsections =  _.filter(this.subsections, subsection => {
        return ids.includes(subsection._id)
      })
      const markers = subsections.map(subsection => {
        subsection.marker.label = subsection.label
        return subsection.marker
      })
      return markers
    },

    isAddingNewObject (model) {
      return _.map(this[model], object => { return object._id }).includes('temp')
    },

    saveLivingOptions () {
      this.saveConfig()
      this.livingOptions.forEach(livingOption => {
        this.$store.dispatch('SAVE_LIVING_OPTION', livingOption)
      })
    },

    saveLivingOption (livingOption) {
      this.$store.dispatch('SAVE_LIVING_OPTION', livingOption)
      this.activeLivingOptionId = null
      this.subsectionsByIds(livingOption.subsectionIds).forEach(subsection => {
        this.$store.dispatch('SAVE_SUBSECTION', subsection)
      })
    },

    saveSubsection (subsection) {
      this.$store.dispatch('SAVE_SUBSECTION', subsection)
      this.activeSubsectionId = null
      this.propertiesByIds(subsection.propertyIds).forEach(property => {
        this.$store.dispatch('SAVE_PROPERTY', property)
      })      
    },

    saveProperty (property) {
      this.$store.dispatch('SAVE_PROPERTY', property)
      this.activePropertyId = null
    },    

    savePropertyModel (propertyModel) {
      this.$store.dispatch('SAVE_PROPERTY_MODEL', propertyModel)
      this.activePropertyModelId = null
    },

    async setData () {
      // Get the config items from the API
      this.configItems = await this.$store.dispatch(FETCH_CONFIG_ITEMS)

      // Reduce to just the live config items
      const liveConfigItems = _.filter(this.configItems, item => {
        return this.livingOptionsConfigItemsKeys.includes(item.key)
      })

      // Map the live items to the component data
      liveConfigItems.forEach(item => {
        this[item.key] = item.value
      })
    }
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_LIVING_OPTIONS')
    this.$store.dispatch('FETCH_SUBSECTIONS')
    this.$store.dispatch('FETCH_PROPERTIES')
    this.$store.dispatch('FETCH_PROPERTY_MODELS')
    this.setData()
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";

  select {
    width: 100%;
  }

  .card {
    z-index: unset !important;
  }

  .living-option, .subsection, .property, .property-model {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;
    margin: 1em 0;
  }

  .selection-list {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;   
    max-height: 200px;
    overflow: scroll; 
  }

  .list-wrapper {
    max-height: 600px;
    overflow: scroll;
  }

  .subsections {
    table {
      border-collapse: separate;
      border-spacing: 0;
      border: 1px solid #d4d4d4;
      border-radius: 6px;
      // overflow: hidden;
      width: 100%;
    }

    .table__button-cell {
      button {
        opacity: 0;
      }
    }

    tbody {
      display: block;
      max-height: none;
      overflow: auto;

      @include v-breakpoint(800px) {
        max-height: calc(100vh - 500px);
      }

      tr:hover {
        background-color: #f5f5f5;
        .table__button-cell button {
          opacity: 1;
        }
      }
    }

    thead, tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }

    thead {
      background-color: #f0f0f0;
      border-bottom: 1px solid #d4d4d4;
      font-size: 12px;
      position: sticky;
      text-transform: uppercase;
      top: 0;
      z-index: 10;
    }

    th, td {
      font-weight: 400;
      padding: 10px 15px;
    }

    tr {
      &:nth-child(2n) {
        background-color: #fafafa;
      }
    }
  }

  .modal-row-padding {
    padding: 30px 0;
  }
</style>